import { ComponentType } from "react";
import { Reducer } from "redux";

import { SagaWithReturnType } from "@multiweb/types/react";
import { NAME } from "./constants";

/** Informace o reduceru potřebné pro jeho zaregistrování */
export type ReducerInfo = {
    readonly name: string;
    readonly reducer: Reducer;
};

/** Podstrom se stavem custom modulů (lze rozšířit ve vlastním projektu o typy vlastních modulů)
 *
 * @example
 * Příklad rozšíření interface o vlastní moduly ve vlastním projektu
 * ```
 * declare module "UI/UI.React/customization/types" {
 *   interface ICustomizationState {
 *     tiles: ITilesState;
 *     auctions: IAuctionsState;
 *   }
 * }
 * ```
 */
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ICustomizationState {}

/** Definice custom modulu určeného k zapojení do stávající aplikace */
export type CustomizationModule = {
    readonly getSaga: () => SagaWithReturnType;
    readonly getReducer: () => Reducer;
    readonly NAME: typeof NAME;
};

/**
 * Typ pro mapu komponent omezenou definovanými názvy komponent a jejich prop typy z generika.
 * @template T Klíče jsou názvy komponenty, hodnoty jejich props
 */
export type ComponentMap<T> = {[key in keyof T]: ComponentType<T[key]>};
